import Vue from 'vue'
// import './plugins/vuetify'

import Vuex from 'vuex'
Vue.use(Vuex)

// import Vuetify from 'vuetify';
// Vue.use(Vuetify)
import App from './App.vue'
import App1 from './App1.vue'
import router from './router'
Vue.config.productionTip = false

if (window.location.href.includes('/admin')) {
  
  new Vue({
    render: h => h(App1)
  }).$mount('#app')

} else {
  
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}